import React from 'react';
import './About.scss';


const About = () => (
  <section className="about-section" id="about">
    <div className="container">
      <div className="row align-items-center g-5">

        {/* Visual card */}
        <div className="col-lg-5">
          <div className="about-visual">
            <div className="visual-card">
              <div className="visual-top">
                <span className="big-emoji">⚙️</span>
                <h3>Precision-Built. Performance-Driven.</h3>
                <p>
                  Since 2010, Aavjo Industries has been at the forefront of India's industrial 
                  automation revolution — combining deep engineering expertise with a 
                  relentless focus on customer outcomes.
                </p>
              </div>
              <div className="certifications">
                <span className="cert-badge">ISO 9001:2015</span>
                <span className="cert-badge">CE Marked</span>
                <span className="cert-badge">BIS Certified</span>
                <span className="cert-badge">Make in India</span>
              </div>
            </div>
          </div>
        </div>

        {/* Text content */}
        <div className="col-lg-7">
          <div className="about-text">
            <div className="section-header">
              <span className="badge-label">Who We Are</span>
              <h1>Aerial Lift &amp; Material Handling Equipment Manufacturer</h1>
              <div className="section-divider" style={{ margin: '.75rem 0 1rem' }} />
            </div>

            <p className="story-para">
              Welcome to Aavjo Industries, a trusted manufacturer of aerial lifts,
              scissor lifts, goods lifts, stackers, pallet trucks and hydraulic
              material handling equipment in Ahmedabad, Gujarat.
            </p>
            <p className="story-para">
              Our aerial work platforms and lifting solutions are built for warehouses,
              factories, maintenance teams and construction sites that need safe access
              at height. With a focus on durability, safety, and efficiency, we aim to
              elevate your operations. Partner with us for tailored equipment that
              drives productivity and growth.
            </p>
            <p className="story-para tagline-quote">
              "We build relationships that last!"
            </p>

            <div className="about-cta">
              <a href="/#contact" className="btn-primary-custom">
                Partner With Us
              </a>
              <span className="btn-link-custom">
                Download Brochure →
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
);

export default About;
